import { render, staticRenderFns } from "./carDetails.vue?vue&type=template&id=3e0ccd49&"
import script from "./carDetails.vue?vue&type=script&lang=js&"
export * from "./carDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports